import { z } from 'zod';
import { School, schoolZod, schoolInfoZod } from '../model';
import { get, post } from './BaseApi';

const schoolInfoListZod = z.array(schoolInfoZod);
type SchoolInfoList = z.infer<typeof schoolInfoListZod>;

export async function getCurrentSchool(): Promise<School> {
  return get('/api/school/current', schoolZod);
}

export async function getSchoolListInfo(
  schoolIds: string[]
): Promise<SchoolInfoList> {
  return await post('/api/school/info', schoolInfoListZod, {schoolIds});
}

export async function promoteSemester(): Promise<void> {
  return post('/api/school/promote');
}

export async function updateSchoolZip(
  schoolIds: string[]
): Promise<SchoolInfoList> {
  return await post('/api/school/update/zip', schoolInfoListZod, {schoolIds});
}
